import React, { useMemo, useState } from 'react'
import { Button, Form, InputGroup, Row, Spinner, Alert } from 'react-bootstrap'
import {
  REPORTID_SUBHEADING,
  CONCENT_LBL_1,
  CONCENT_LBL_2,
  INVALID_ID_WARNING,
  DISCLAIMER,
  DOWNLOAD_TEXT,
  PURPOSE_OF_SEARCH_OPTIONS,
  RESTRICTED_REPORT,
  NCA_TEXT,
  CMAINFO_DISCLAIMER,
  PRICELIST,
} from '../../utils/Constants'
import '../../index.css'
import { validateIdNumber } from '../../utils/Validation'
import FormInputWithAlert from '../../components/form/FormInput/FormInputWithAlert'
import TextArea from '../../components/form/TextArea/TextArea'
import ScreenHeader from '../../components/kyc/ScreenHeader'
import FormInput from '../../components/form/FormInput/FormInput'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import Checkbox from '../../components/form/Checkbox/Checkbox'
import { ReportTypes } from '../../api/apiConstants'
import { ReportResponseForm } from '../../components/kyc/ReportResponseForm'
import SearchBySelect from '../../components/form/SearchBySelect/SearchBySelect'
import { API_ERROR_MESSAGE } from '../../utils/Constants'
import './CreditReportById.css'
import CreditReportResultTable from '../../components/kyc/CreditReportResultTable'
import axios, { AxiosResponse } from 'axios'
import { getAPIUrl } from '../../api/API'
import { useMutation } from 'react-query'
import { useCreditReportCandidateSearch } from './hooks'
import KycButton from '../../components/form/Button/Button'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import moment from 'moment'

enum SearchTypes {
  ID = 'id',
  PASSPORT = 'passport',
  PERSONAL = 'personal',
}

import NewAndCloseButtons from '../../components/form/NewAndCloseButtons/NewAndCloseButtons'
import '../../components/form/FormInput/FormInput.css'
import { useDownloadFile } from '../../hooks/use-download-file'
import { ReactDatePicker } from '../../components/kyc/ReactDatePicker'
interface CreditReportByIdProps {
  handleClose: () => void
  identityNumber: string
  passportNumber: string
  setUIDNumber: (uidNumber: {
    target: { value: React.SetStateAction<string> }
  }) => void
  setUPPNumber: (value: string) => void
  firstName: string
  surname: string
  creditReportPurpose: string
  setCreditReportPurpose: (value: string) => void
  setSurname: (value: string) => void
  setFirstName: (value: string) => void
  concent1: boolean
  setFirstConcent: (value: boolean) => void
  concent2: boolean
  KYCAccess: boolean
  showOTPFields: boolean
  showDownloadReport: boolean
  handleSearch?: () => void
  setSecondConcent: (value: boolean) => void
  // validateFields: () => boolean
  showProgress: boolean
  initialState: { [key: string]: any }
  setInitialState: React.Dispatch<React.SetStateAction<any>>
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
  setReportType: (value: number) => void
  reference: string
  setReference: (value: string) => void
  handleClick: () => void
  creditSearchResults: any[]
  setCreditSearchResults: (value: any[]) => void
  setShow: (value: boolean) => void
  handleStartOver: () => void
}

export type Person = {
  consumerID: string
  idno: string
  passportnumber: string
  firstname: string
  secondname: string
  thirdname: string
  surname: string
  birthDate: string
  gender: string
  enquiryID: number
  enquiryResultID: number
  reference: string
}

const CreditReportById: React.FC<CreditReportByIdProps> = ({
  handleClose,
  identityNumber,
  passportNumber,
  setUIDNumber,
  setUPPNumber,
  // validateFields,
  firstName,
  setFirstName,
  surname,
  setSurname,
  setCreditReportPurpose,
  concent1,
  setFirstConcent,
  concent2,
  showOTPFields,
  KYCAccess,
  showDownloadReport,
  setSecondConcent,
  initialState,
  setInitialState,
  setShow,
  setIsError,
  setErrorMessage,
  setReportType,
  reference,
  setReference,
  handleClick,
  creditSearchResults,
  setCreditSearchResults,
  creditReportPurpose,
}) => {
  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      creditReportById: {
        identityNumber: identityNumber,
        reference: reference,
      },
    })
  }

  const onSearch = () => {
    const missingFields = validateFields()
    if (missingFields.length === 0) {
      setReportType(ReportTypes.CreditEnquiryReport.reportTypeId)
      updateInitialState()
      searchCreditReportCandidate()
    } else {
      alert(`Please complete the following fields: ${missingFields.join(', ')}`)
    }
  }
  const [searchType, setSearchType] = useState<string>(SearchTypes.ID)

  const [isOtp, setIsOtp] = useState(false)
  const [OTPValue, setOTPValue] = useState('')
  const [selected, setSelected] = useState<Person | null>(null)
  const [isDownload, setIsDownload] = useState(false)
  const [reportId, setReportId] = useState('')
  const [otpSpinner, setOtpSpinner] = useState(false)
  const [_date, set_Date] = useState<Date | null>(null)

  const handleStartOver = () => {
    setIsOtp(false)
    setIsDownload(false)
    setCreditSearchResults([])
    setFirstName('')
    setOTPValue('')
    setUIDNumber({ target: { value: '' } })
    setSurname('')
    setUPPNumber('')
    set_Date(null)
    setCreditReportPurpose('')
    setReference('')
    setFirstConcent(false)
    setSecondConcent(false)
  }

  const validateFields = () => {
    const missingFields = []
    if (searchType === SearchTypes.ID) {
      if (identityNumber === '') missingFields.push('Identity Number')
      else if (!validateIdNumber(identityNumber))
        missingFields.push('Invalid Identity Number')
    } else if (searchType === SearchTypes.PASSPORT) {
      if (passportNumber === '') missingFields.push('Passport Number')
    } else {
      if (firstName === '') missingFields.push('First Name')
      if (surname === '') missingFields.push('Surname')
      if (!_date) missingFields.push('Date of Birth')
    }
    if (creditReportPurpose === '') missingFields.push('Prescribed Purpose')
    if (!concent1) missingFields.push('Consent 1')
    if (!concent2) missingFields.push('Consent 2')
    return missingFields
  }

  const { searchCreditReportCandidate, isLoading } =
    useCreditReportCandidateSearch(
      {
        identityNumber: identityNumber ?? undefined,
        passportNumber: passportNumber ?? undefined,
        firstName: firstName ?? undefined,
        lastName: surname ?? undefined,
        dateOfBirth: _date ? moment(_date).format('YYYY-MM-DD') : null,
        purpose: creditReportPurpose,
        productId: 15,
        reportType: 1,
        reference,
      },
      (data) => {
        if (data.length === 0) {
          let searchCriteria = ''
          if (identityNumber)
            searchCriteria += `Identity Number: ${identityNumber} `
          if (passportNumber)
            searchCriteria += `Passport Number: ${passportNumber} `
          if (firstName) searchCriteria += `First Name: ${firstName} `
          if (surname) searchCriteria += `Last Name: ${surname} `
          if (_date)
            searchCriteria += `Date of Birth: ${moment(_date).format(
              'YYYY-MM-DD',
            )} `
          alert(`No results found for: ${searchCriteria}`)
        } else {
          setCreditSearchResults(data)
        }
      },
      (e: any) => {
        setIsError(true)
        if (e.response && e.response.data.statusCode === 500) {
          setErrorMessage('No results found! Please try again')
        } else {
          setErrorMessage('Error searching for candidate')
        }
      },
    )

  const { mutate: sendOtp, isLoading: sendingOtp } = useMutation(
    'send-otp',
    async () => {
      const res = await axios.post(
        getAPIUrl() + '/Common/send-otp',
        {
          productId: 15,
        },
        {
          headers: {
            Authorization: 'bearer ' + sessionStorage.getItem('jwt'),
          },
        },
      )
      return res.data
    },
    {
      onSuccess: (response: any) => {
        setIsOtp(true)
        setOtpSpinner(false)
      },
    },
  )

  const { mutate: downloadReport, isLoading: downloadingReport } =
    useDownloadFile(
      '/CreditEnquiry/download-report',
      reportId,
      ReportTypes.CreditEnquiryReport.reportTypeId,
      setIsError,
      setErrorMessage,
    )

  const handleSetSearchTypes = (selectedOptionValue: string) => {
    setFirstName('')
    setReference('')
    setUIDNumber({ target: { value: '' } })
    setUPPNumber('')
    setSurname('')
    set_Date(null)
    setSearchType(selectedOptionValue)
  }
  const id = useMemo(() => {
    if (searchType === SearchTypes.PERSONAL) {
      if (selected?.idno) return selected?.idno ?? null
      if (selected?.passportnumber) return selected?.passportnumber ?? null
    }
    if (searchType === SearchTypes.ID) return selected?.idno ?? null
    if (searchType === SearchTypes.PASSPORT)
      return selected?.passportnumber ?? null
    return null
  }, [identityNumber, passportNumber, searchType, selected])

  const { mutate: fetchReport, isLoading: fetchingReport } = useMutation(
    'fetch-report',
    async () => {
      const res = await axios.post(
        getAPIUrl() + '/CreditEnquiry/load-report',
        {
          otpForValidation: OTPValue,
          identityNumber: id,
          enquiryID: selected?.enquiryID,
          enquiryResultID: selected?.enquiryResultID,
          reference: selected?.reference,
          purpose: creditReportPurpose,
          productId: 15,
          reportType: 1,
          individualConsent: true,
          purposeConsent: true,
        },
        {
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
          },
        },
      )
      return res.data
    },
    {
      onSuccess: (response: any) => {
        setReportId(response.data.reportId)
        downloadReport(response.data.reportId)
      },
      onError: (error: any) => {
        setIsError(true)
        setErrorMessage(error?.response?.data?.message || API_ERROR_MESSAGE)
      },
    },
  )

  const handleOtp = (person: Person) => {
    setSelected(person)
    sendOtp()
  }

  if (isDownload)
    return (
      <ScreenLayout
        price={PRICELIST.CREDIT_REPORT}
        headerText="CREDIT REPORT"
        subHeaderText={REPORTID_SUBHEADING}
        sampleReport={'CreditReportOwner.pdf'}
      >
        <div style={{ maxWidth: '180px' }}>
          <KycButton
            onClick={downloadReport as any}
            variant={'primary'}
            children={'Download Report'}
            isLoading={downloadingReport}
            size="lg"
          />
          <br />
        </div>
        <NewAndCloseButtons
          handleAction={handleStartOver}
          handleClose={setShow}
        />
      </ScreenLayout>
    )

  if (isOtp)
    return (
      <ScreenLayout
        price={PRICELIST.CREDIT_REPORT}
        headerText="CREDIT REPORT"
        subHeaderText={REPORTID_SUBHEADING}
        sampleReport={'CreditReportOwner.pdf'}
      >
        {fetchingReport && (
          <>
            <div className="spinner-container">
              <Spinner
                as="span"
                animation="border"
                variant="dark"
                role="status"
                aria-hidden="true"
              ></Spinner>
              <span> </span>
            </div>
          </>
        )}
        {!isDownload && otpSpinner && (
          <>
            <div className="spinner-container">
              <Spinner
                as="span"
                animation="border"
                variant="dark"
                role="status"
                aria-hidden="true"
              ></Spinner>
              <span> </span>
            </div>
          </>
        )}
        <>
          <Form.Group
            as={Row}
            className="mb-1 ml-1"
            controlId="KYCForm.ControlInput2"
            style={{ maxWidth: '430px' }}
          >
            <p>
              Please enter the OTP that has been sent to your registered email
              address. <br />
              <KycButton
                variant={'primary'}
                children={'Resend OTP'}
                onClick={() => {
                  setIsDownload(false)
                  setOtpSpinner(true)
                  sendOtp()
                  setOTPValue('')
                }}
              />
            </p>
            <Form.Group className="mb-1" controlId="KYCForm.ControlInput2">
              <Form.Control
                type="input"
                value={OTPValue}
                placeholder="Please enter the OTP that has been sent to your registered email address."
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault()
                  }
                }}
                onChange={(val) => {
                  setOTPValue(val.target.value)
                }}
              />
            </Form.Group>
            <div className="footer-btns">
              <Button
                className="btn-lg btn-kyc"
                onClick={() => fetchReport()}
                disabled={OTPValue.length === 0}
              >
                Verify
              </Button>

              <Button
                className="btn-lg btn-kyc-inverse m-l-10"
                style={{
                  backgroundColor: 'rgb(255, 255, 255)',
                  borderColor: '#7f7f7f',
                  color: '#7f7f7f',
                }}
                onClick={() => {
                  setIsOtp(false)
                  setOTPValue('')
                }}
              >
                Back
              </Button>
            </div>
          </Form.Group>
        </>
      </ScreenLayout>
    )

  if (creditSearchResults.length > 0)
    return (
      <ScreenLayout
        price={PRICELIST.CREDIT_REPORT}
        headerText="CREDIT REPORT"
        subHeaderText={REPORTID_SUBHEADING}
        sampleReport={'CreditReportOwner.pdf'}
      >
        <CreditReportResultTable
          showProgress={sendingOtp}
          handleLoadCreditReport={handleOtp}
          results={creditSearchResults}
        />
        <div className="footer-btns">
          <Button
            className="btn-lg btn-kyc-inverse m-l-10"
            style={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderColor: '#7f7f7f',
              color: '#7f7f7f',
            }}
            onClick={() => handleStartOver()}
          >
            New Search
          </Button>
          <Button
            className="btn-lg btn-kyc-inverse m-l-10"
            style={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderColor: '#7f7f7f',
              color: '#7f7f7f',
              minWidth: '100px',
            }}
            onClick={() => setCreditSearchResults([])}
          >
            Back
          </Button>
        </div>
      </ScreenLayout>
    )

  return (
    <ScreenLayout
      price={PRICELIST.CREDIT_REPORT}
      headerText="CREDIT REPORT"
      subHeaderText={REPORTID_SUBHEADING}
      sampleReport={'CreditReportOwner.pdf'}
    >
      {isLoading && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      <div>
        {!KYCAccess && <p className="lbl-red">{RESTRICTED_REPORT}</p>}
        <SearchBySelect
          required
          className="mb-3"
          onChangeHandler={(selectedOptionValue: string) =>
            handleSetSearchTypes(selectedOptionValue)
          }
          options={[
            { value: '', label: '- Search By -' },
            { value: SearchTypes.ID, label: 'ID Number' },
            { value: SearchTypes.PASSPORT, label: 'Passport Number' },
            { value: SearchTypes.PERSONAL, label: 'Personal Details' },
          ]}
        />
      </div>
      {searchType === SearchTypes.ID && (
        <FormInputWithAlert
          value={identityNumber}
          setValue={setUIDNumber}
          required
          className="mb-3"
          placeholder="Unique identity number"
          validationFunction={validateIdNumber}
          validationMessage={INVALID_ID_WARNING}
        />
      )}
      {searchType === SearchTypes.PASSPORT && (
        <FormInput
          value={passportNumber}
          className="mb-3"
          onChangeHandler={(value) => setUPPNumber(value)}
          placeHolderText="Passport number"
        />
      )}
      {searchType === SearchTypes.PERSONAL && (
        <>
          <FormInput
            className="mb-3"
            placeHolderText="Surname"
            onChangeHandler={setSurname}
            value={surname}
          />
          <FormInput
            className="mb-3"
            placeHolderText="Name"
            onChangeHandler={setFirstName}
            value={firstName}
          />
          <InputGroup
            style={{ width: '100%', maxWidth: '430px', zIndex: 10 }}
            className="mb-3"
          >
            <ReactDatePicker
              selected={_date}
              onChange={(date: Date) => set_Date(date)}
              placeholderText="CCYY-MM-DD"
            />
          </InputGroup>
        </>
      )}
      <SearchBySelect
        required
        className="mb-3"
        onChangeHandler={setCreditReportPurpose}
        options={PURPOSE_OF_SEARCH_OPTIONS}
      />
      <div className="mb-2" style={{ maxWidth: '430px' }}>
        <FormInput
          placeHolderText="Search reference (optional)"
          onChangeHandler={setReference}
          value={reference}
        />
      </div>
      <Checkbox
        className="checkBoxes"
        label={
          <span className="checkBoxLabelText">
            I confirm that consent has been received from the individual(s), of
            which <br />
            evidence must be made available in the event of an audit.{' '}
          </span>
        }
        checked={concent1}
        onChangeHandler={() => {
          setFirstConcent(!concent1)
        }}
        required
      />
      <Checkbox
        className="checkBoxes"
        label={
          <span className="checkBoxLabelText">
            I declare I am accessing this information for it's prescribed or
            contemplated <br />
            purpose only. I will not alter or amend the credit report.{' '}
          </span>
        }
        checked={concent2}
        onChangeHandler={() => {
          setSecondConcent(!concent2)
        }}
        required
      />
      <span className="legalText">{NCA_TEXT}</span>
      <span className="legalText">{DOWNLOAD_TEXT}</span>
      {!showOTPFields && !showDownloadReport && (
        <>
          <FooterButtons
            searchClose="Close"
            setShow={setShow}
            isDisabled={!validateFields()}
            handleSearch={onSearch}
            handleClose={() => setShow(false)}
            isLoading={isLoading}
          />
          <p className="disclaimer">{DISCLAIMER}</p>
          <span className="cmaDisclaimerCR">{CMAINFO_DISCLAIMER}</span>
        </>
      )}
      {showDownloadReport && !showOTPFields && (
        <>
          <div>
            <KycButton
              onClick={() => downloadReport(reportId)}
              variant={'primary'}
              children={'Download Report'}
              isLoading={downloadingReport}
              size="lg"
            />
          </div>
          <NewAndCloseButtons
            handleAction={handleStartOver}
            handleClose={handleClose}
          />
          <p className="legalText">{NCA_TEXT}</p>
          <p className="belowLegal">{DOWNLOAD_TEXT}</p>
        </>
      )}
    </ScreenLayout>
  )
}
export default CreditReportById
